import { AccountUserLongLifeAccessToken } from '@/service';

/**
 * @class @name LongLifeAccessToken
 * @description Exposes menu store module
 */
export default class LongLifeAccessToken {
	/**
	 * @method @static @get @name namespaced
	 * @description Is this module namespaced?
	 */
	static get namespaced() {
		return true;
	}

	/**
	 * @method @static @get @name state
	 * @description Expose state as an object, compatible with vue stores
	 */
	static get state() {
		return {};
	}

	/**
	 * @method @static @get @name getters
	 * @description Expose getters as an object, compatible with vue stores
	 */
	static get getters() {
		return {};
	}

	/**
	 * @method @static @get @name mutations
	 * @description Expose mutations as an object, compatible with vue stores
	 */
	static get mutations() {
		return {};
	}

	/**
	 * @method @static @get @name actions
	 * @description Expose action as an object, compatible with vue stores
	 */
	static get actions() {
		return {
			/**
			 * @async @name loadUserLongLifeAccessTokensList
			 * @description load users tokens
			 * @param {function} commit
			 * @param {Object} payload
			 */
			async loadUserLongLifeAccessTokensList(store, payload) {
				return AccountUserLongLifeAccessToken.list(payload);
			},

			/**
			 * @async @name createUserLongLifeAccessToken
			 * @description create token
			 * @param {function} commit
			 * @param {Object} payload
			 */
			async createUserLongLifeAccessToken(store, payload) {
				return AccountUserLongLifeAccessToken.post(payload);
			},

			/**
			 * @async @name deleteUserLongLifeAccessToken
			 * @description delete token
			 * @param {function} commit
			 * @param {Object} payload
			 */
			async deleteUserLongLifeAccessToken(store, payload) {
				return AccountUserLongLifeAccessToken.delete(payload);
			}
		};
	}
}
